"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.difference = void 0;
var lodash_differencewith_1 = __importDefault(require("lodash.differencewith"));
var isEqual_1 = require("./isEqual");
var fromPairs_1 = require("./fromPairs");
var toPairs_1 = require("./toPairs");
var difference = function (object, otherObject) {
    var pairsOther = (0, toPairs_1.toPairs)(otherObject);
    var pairsObject = (0, toPairs_1.toPairs)(object);
    var pairsDifference = (0, lodash_differencewith_1["default"])(pairsOther, pairsObject, isEqual_1.isEqual);
    return (0, fromPairs_1.fromPairs)(pairsDifference);
};
exports.difference = difference;
//# sourceMappingURL=difference.js.map